import Vue from 'vue';
import Vuex from 'vuex';

// Load modules
import account from './modules/account';
import cards from './modules/cards';
import dashboard from './modules/dashboard';
import tenant from './modules/tenant';
import featureFlag from './modules/st_feature_flag';
import filter from './modules/filter';
import misc from './modules/misc';
import user from './modules/user';
import userGroup from './modules/userGroup';
import universe from './modules/universe';

// Add logRocket and LogRocket vuex plugin
import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

const logrocketPlugin = createPlugin(LogRocket);

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    account,
    cards,
    dashboard,
    tenant,
    featureFlag,
    filter,
    misc,
    user,
    userGroup,
    universe,
  },
  plugins: [logrocketPlugin],
});
